import { getPinsByTag } from "@/services";
import { useGetState, useMount, useUpdateEffect } from "ahooks";
import { Button } from "antd";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";
import HBIcon from "../../HBIcon";
import PinList from "../../PinList";
import styles from "../index.module.less";
import TabPanel from "./TabPanel";
import UserTags from "./UserTags";

export default function TagListPanel({
  urlname,
  tagName,
  isMe,
  initTags = null,
  initTagPins = null,
}) {
  const router = useRouter();

  const [curTag, setCurTag] = useState(tagName);
  const [records, setRecords, getRecords] = useGetState(initTagPins || []);
  const [hasMore, setHasMore] = useState(false);

  const loadData = useCallback(
    async (tag_name) => {
      if (!tag_name) {
        setRecords([]);
        return;
      }

      const PAGE_SIZE = 30;
      const records = getRecords();
      const isNewTag = curTag !== tag_name;
      const { err, pins } = await getPinsByTag({
        urlname,
        tag_name: encodeURIComponent(tag_name),
        limit: PAGE_SIZE,
        max: isNewTag ? undefined : records[records.length - 1]?.seq,
      });
      if (err) return;

      const t = [...records, ...pins];
      setRecords(t);
      setHasMore(pins.length >= PAGE_SIZE);
    },
    [curTag, getRecords, setRecords, urlname]
  );

  useUpdateEffect(() => setCurTag(tagName), [tagName]);
  useUpdateEffect(() => loadData(curTag), [curTag]);

  const gotoTagPanel = useCallback(() => {
    setCurTag(null);
    router.push(`/space/tags`);
  }, [router]);

  const loadMore = useCallback(() => loadData(curTag), [curTag, loadData]);

  useMount(() => !initTagPins && loadData(curTag));

  return (
    <TabPanel>
      {curTag ? (
        <>
          <div style={{ margin: "16px 0" }}>
            所选标签：
            <Button
              className={styles.tagButton}
              type="text"
              onClick={gotoTagPanel}
            >
              {curTag}
              <HBIcon className={styles.icon} type="ic_clear2" />
            </Button>
          </div>

          <PinList
            dataSource={records}
            hasMore={hasMore}
            hideUser
            onLoadMore={loadMore}
          />
        </>
      ) : (
        <UserTags urlname={urlname} isMe={isMe} initTags={initTags} />
      )}
    </TabPanel>
  );
}
